// extracted by css-extract-rspack-plugin
export default {"completed-orders-heading":"WBjyp6","completedOrdersHeading":"WBjyp6","show-more":"wvGylH","showMore":"wvGylH"};